import React, { useEffect, useState } from "react"
import { gamesLookupService } from "../../../modules/games/games-lookup"
import { ActivityGame, GameProvider } from "../../../modules/games/game"
import { GameCard } from "./game-card"
import { Container } from "reactstrap"
import { Link } from "react-router-dom"
import { accessibleService } from "../../../modules/center-services/AccessibleService"

type GamesHomeProps = {

}

export const GamesHome = (props: GamesHomeProps) =>{

  const [allGames, setAllGames] = useState<ActivityGame[]>([]);
  const [games, setGames] = useState<ActivityGame[]>([]);
  const [subjectSelection, setSubjectSelection] = useState<Record<string, boolean>>({math: true, english: true})
  const [initialised, setInitialised] = useState<boolean>(false);
  const [accessible, setAccessible] = useState<boolean>(false);
  const MYGOOROO = (GameProvider as any)?.MYGOOROO ?? "mygooroo";

  useEffect(() => {
    async function fetchGames(){
      const _games = await gamesLookupService.getGames();
      setAllGames(_games);
    }
        async function fetchAccess() {
            await accessibleService.init();
            setAccessible(accessibleService.hasAccessToGames());
        }
        Promise.all([fetchGames(), fetchAccess()]).then(() => setInitialised(true));
  }, [])

  useEffect( ()=>{
    setGames(allGames);
  }, [allGames])

  useEffect (()=>{
    filterGames();
  }, [subjectSelection])

  function filterGames(){
    const filteredGames = allGames.filter( game=>{
      let result = true;

      result = result && subjectSelection[game.subject]

      return result;
    })

    setGames(filteredGames);
  }

  function toggleSubject(subject: string) {
    setSubjectSelection( e=> {
      const result = {...e};
      result[subject] = !result[subject];
      return result
    });
  }

    const banner = (text: string) => (
        <div
            className="d-flex justify-content-center mb-2 p-2 font-size-20"
            style={{
                backgroundColor: "#007bff",
                color: "#ffffff",
                fontWeight: "bold",
                borderRadius: "4px",
                padding: "0.5rem 1rem",
            }}
        >
            <p className="mb-0" style={{ color: "#ffffff" }}>
                {text}
            </p>
        </div>
    );

    if (!initialised) {
        return null;
    }

  return (
    <div className="page-wrapper list-bg">
      <div className="cs-pg-header bg-dark-blue py-3">
        <Container className="custom-wt">
          <div className="">
            <div className="mt-0">
              <Link className="text-white font-size-14" to={"/"}>
                {" "}
                <span>
                    <i className="fas fa-chevron-left me-1"></i>
                  </span>{" "}
                BACK TO HOME
              </Link>
              <div className="pg-title w-75 m-auto">Games</div>
            </div>

          </div>
        </Container>
      </div>
      <Container className="custom-wt mt-2 px-4">
                {accessible
                    ? banner("Centre Games add-on is active.")
                    : banner("Your centre has not subscribed to the Enrichment & Games bundle.")}

        <div className={"mt-2"}>
          <div className={"d-flex gap-2 font-size-20 justify-content-start align-items-center"}>
            Subject:
            <span className="badge cursor-pointer px-5" onClick={()=>toggleSubject('math')}
                  style={{backgroundColor: subjectSelection['math'] ? '#2196f3' : '#8d9fb6'}}>Math</span>
            <span className="badge cursor-pointer px-5"  onClick={()=>toggleSubject('english')}
                  style={{backgroundColor: subjectSelection['english'] ? '#2196f3' : '#8d9fb6'}}>English</span>
          </div>
        </div>

        <div className={"d-flex w-100 flex-wrap gap-5 mt-2"}>
          {games.map(game =>{
              const canPlay = accessible || game.providerId === MYGOOROO;
              return <GameCard key={`${game.providerId}:${game.providerGameId}`} game={game} canPlay={canPlay} />
          })}
        </div>
      </Container>
    </div>

  )
}